import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { TextInput } from '../../../models/inputs/text-input';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-textbox-input',
    standalone: true,
    imports: [InputTextModule, FormsModule, ReactiveFormsModule, TranslateModule],
    template: `
        <input
            [autocomplete]="control.autocomplete"
            id="{{ 'input' + name }}"
            class="form-control"
            [class]="control.inputClass.join(' ')"
            pInputText
            [type]="control.clearable ? 'search' : control.type"
            [placeholder]="control.placeholder! | translate"
            [formControl]="control"
        />
    `
})
export class TextboxInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: TextInput;
}
